// Junta nomes em prosa: "A, B e C" (ou "A, B ou C").
const listNames = (
  items: ReadonlyArray<{ name: string }>,
  conjunction: 'e' | 'ou' = 'e',
): string => {
  const names = items.map(({ name }) => name)

  if (names.length <= 1) return names.join('')

  return `${names.slice(0, -1).join(', ')} ${conjunction} ${names[names.length - 1]}`
}

export { listNames }
